// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Footer.css */
.footer {
  background-color: #000;
  color: #fff;
  padding: 20px 0;
  z-index: 100;
  width: 100%;
}

.footer .social-link {
  color: #fff;
  text-decoration: none;
  margin: 0 10px;
}

.footer .social-link:hover {
  text-decoration: underline;
}

.footer .logo {
  padding-bottom: 1rem;
}

.footer .contact-info-inline {
  display: flex;
  justify-content: center;
  align-items: center;
}

.footer .contact-info-inline p {
  margin: 0 20px; /* Adjust space between items as needed */
  cursor: default; /* Ensure cursor does not change to pointer */
}

body, html, #root {
  height: 100%;
  margin: 0;
  padding: 0;
}

.App {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.content {
  flex: 1 1;
  padding-top: 70px; /* Ensure navbar does not overlap content */
}

.footer .fa-2x {
  font-size: 1.5em;
}

.non-clickable {
  cursor: default; /* Ensure cursor does not change to pointer */
}

.phone-link-2 {
  color: inherit; /* Inherit color from parent */
  text-decoration: none; /* Remove underline */
}

.phone-link-2:hover,
.phone-link-2:focus,
.phone-link-2:active {
  color: inherit; /* Inherit color on hover/focus/active */
  text-decoration: none; /* Remove underline on hover/focus/active */
}

/* Mobile specific CSS */
@media (max-width: 768px) {
  .footer .contact-info-inline {
    flex-direction: column;
    align-items: center;
  }

  .footer .contact-info-inline p {
    margin: 10px 0; /* Adjust space between items as needed */
  }

  .footer .social-link {
    margin: 5px 0;
    padding-right: 20px;
    padding-left: 20px;
  }

  .footer .logo {
    text-align: center;
    padding-bottom: 1rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/footer/Footer.css"],"names":[],"mappings":"AAAA,eAAe;AACf;EACE,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc,EAAE,yCAAyC;EACzD,eAAe,EAAE,6CAA6C;AAChE;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,iBAAiB,EAAE,2CAA2C;AAChE;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe,EAAE,6CAA6C;AAChE;;AAEA;EACE,cAAc,EAAE,8BAA8B;EAC9C,qBAAqB,EAAE,qBAAqB;AAC9C;;AAEA;;;EAGE,cAAc,EAAE,wCAAwC;EACxD,qBAAqB,EAAE,2CAA2C;AACpE;;AAEA,wBAAwB;AACxB;EACE;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,cAAc,EAAE,yCAAyC;EAC3D;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,oBAAoB;EACtB;AACF","sourcesContent":["/* Footer.css */\n.footer {\n  background-color: #000;\n  color: #fff;\n  padding: 20px 0;\n  z-index: 100;\n  width: 100%;\n}\n\n.footer .social-link {\n  color: #fff;\n  text-decoration: none;\n  margin: 0 10px;\n}\n\n.footer .social-link:hover {\n  text-decoration: underline;\n}\n\n.footer .logo {\n  padding-bottom: 1rem;\n}\n\n.footer .contact-info-inline {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.footer .contact-info-inline p {\n  margin: 0 20px; /* Adjust space between items as needed */\n  cursor: default; /* Ensure cursor does not change to pointer */\n}\n\nbody, html, #root {\n  height: 100%;\n  margin: 0;\n  padding: 0;\n}\n\n.App {\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n}\n\n.content {\n  flex: 1;\n  padding-top: 70px; /* Ensure navbar does not overlap content */\n}\n\n.footer .fa-2x {\n  font-size: 1.5em;\n}\n\n.non-clickable {\n  cursor: default; /* Ensure cursor does not change to pointer */\n}\n\n.phone-link-2 {\n  color: inherit; /* Inherit color from parent */\n  text-decoration: none; /* Remove underline */\n}\n\n.phone-link-2:hover,\n.phone-link-2:focus,\n.phone-link-2:active {\n  color: inherit; /* Inherit color on hover/focus/active */\n  text-decoration: none; /* Remove underline on hover/focus/active */\n}\n\n/* Mobile specific CSS */\n@media (max-width: 768px) {\n  .footer .contact-info-inline {\n    flex-direction: column;\n    align-items: center;\n  }\n\n  .footer .contact-info-inline p {\n    margin: 10px 0; /* Adjust space between items as needed */\n  }\n\n  .footer .social-link {\n    margin: 5px 0;\n    padding-right: 20px;\n    padding-left: 20px;\n  }\n\n  .footer .logo {\n    text-align: center;\n    padding-bottom: 1rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
